import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-construcao-variaveis-tabset',
  templateUrl: './construcao-variaveis-tabset.component.html',
  styleUrls: ['./construcao-variaveis-tabset.component.css']
})
export class ConstrucaoVariaveisTabsetComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}




// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/construcao-variaveis/construcao-variaveis-tabset/construcao-variaveis-tabset.component.ts